import { defineComponent, nextTick } from "vue";
import StepFormConsents from "./StepFormConsents";
import StepFormSummary from "./StepFormSummary";
import StepFormInvoice from "./StepFormInvoice";
import OrderLayout from "../../layouts/OrderLayout";
import Utils from "../../utils/Utils";
import { OfferJson } from "../../OrderForm";

export default defineComponent({
    components: {
        StepFormInvoice,
        StepFormConsents,
        StepFormSummary,
        OrderLayout,
    },

    template: `
        <OrderLayout :options="options" :step="step" :wrapper="932" :title="step_title" @offer:change="$emit('back')">
            <div class="StepForm">
                <StepFormInvoice :options="options" :step="step" @next="setStep('consents', options.offer)" @goto="gotoStep" :visible_upload="visible_upload" @back="$emit('back')" @upload="$emit('upload')" />
                <StepFormConsents :options="options" :step="step" @next="setStep('summary', options.offer)" @goto="gotoStep" />
                <StepFormSummary :options="options" :step="step" @goto="gotoStep" />
            </div>
        </OrderLayout>
    `,

    emits: [
        'back',
        'verify',
        'upload',
    ],

    props: {
        /** @var Json */
        options: { type: Object, required: true },

        visible_upload: { type: Boolean, default: false },

        step_prefix: { type: String, required: true },
    },

    computed: {
        breadcrumbstep() {
            if (this.isStep('invoice')) {
                return 2;
            } else if (this.isStep('consents')) {
                return 2;
            } else if (this.isStep('summary')) {
                return 3;
            }
        },

        step() {
            if (this.isStep('invoice')) {
                return 1;
            } else if (this.isStep('consents')) {
                return 2;
            } else if (this.isStep('summary')) {
                return 3;
            }
        },

        step_title() {
            if (this.isStep('invoice')) {
                return `Uzupełnij brakujące dane`;
            } else if (this.isStep('consents')) {
                return `Coraz bliżej...`;
            } else if (this.isStep('summary')) {
                return `To już!<br>Sprawdź, czy wszystko jest OK`;
            }
        },
    },

    watch: {
        '$root.step'(step: string) {
            let $el = null;

            if (this.isStep('invoice')) {
                $el = $('.StepBox--1');
            } else if (this.isStep('consents')) {
                $el = $('.StepBox--2');
            } else if (this.isStep('summary')) {
                $el = $('.StepBox--3');
            }

            if ($el) {
                nextTick(() => {
                    Utils.scrollToEl($el);
                });
            }
        },
    },

    mounted() {
        nextTick(() => {
            Utils.scrollToEl($('.OrderLayout, .StepForm'));
        });
    },

    methods: {
        isStep(val: string) {
            return Utils.isStep(this.step_prefix + val);
        },

        setStep(step: string, offer?: OfferJson) {
            Utils.setStep(this.step_prefix + step, offer);
        },

        async gotoStep(step: number) {
            const offer: OfferJson = this.options.offer;

            switch (step) {
                case 1:
                    if (this.options.edited) {
                        return this.setStep('invoice', offer);
                    } else {
                        await Utils.setCart('accept-info', {
                            unverify: true,
                        });

                        this.$emit('verify');

                        return;
                    }

                case 2:
                    return this.setStep('consents', offer);

                case 3:
                    return this.setStep('summary', offer);
            }
        },
    },
});
